import { ConfirmPopup } from '@neo/blocks/confirm-popup'
import { agentEventBus } from 'v2/utils/event-bus/agent'
import { useFlowStore } from '../store'
import type { FlowNodeTypes } from '../types'
import { detectUnsavedChanges } from '../utils'
import { compareWithIgnoredFields } from '../utils/sidebar-form-filter-fields'

export const UnsavedChangesModal = () => {
  const unsavedModalOpen = useFlowStore((state) => state.unsavedModalOpen)
  const setUnsavedModalOpen = useFlowStore((state) => state.setUnsavedModalOpen)
  const discardChanges = useFlowStore((state) => state.discardChanges)
  const selectedNodeID = useFlowStore((state) => state.selectedNodeID)
  const sidebarFormInstance = useFlowStore((state) => state.sidebarFormInstance)
  const flowInstance = useFlowStore((state) => state.flowInstance)
  const isEditing = useFlowStore((state) => state.isEditing)

  const handleClick = (isOk: boolean) => {
    if (isOk) {
      discardChanges()

      // Detect what type of unsaved changes we have and emit the appropriate event
      const formData = sidebarFormInstance?.state.values
      const nodes = flowInstance?.getNodes() || []
      const nodeData = nodes.find((node) => node.id === selectedNodeID)
      const initialValues = sidebarFormInstance?.options?.defaultValues
      const hasSidebarFormChanges =
        !!selectedNodeID &&
        !!initialValues &&
        !!formData &&
        !!nodeData?.type &&
        !compareWithIgnoredFields(initialValues, formData, nodeData.type as FlowNodeTypes)
      const hasFlowChanges = isEditing && detectUnsavedChanges()

      // Emit the appropriate event based on the type of unsaved changes
      if (hasSidebarFormChanges) {
        agentEventBus.emit('SIDEBAR_FORM_UNSAVED_CHANGES_RESPONSE', true)
      }
      if (hasFlowChanges) {
        agentEventBus.emit('UNSAVED_CHANGES_POPUP_RESPONSE', true)
      }
    } else {
      // For cancel, emit both events with false to ensure all listeners are notified
      agentEventBus.emit('SIDEBAR_FORM_UNSAVED_CHANGES_RESPONSE', false)
      agentEventBus.emit('UNSAVED_CHANGES_POPUP_RESPONSE', false)
    }
    setUnsavedModalOpen(false)
  }

  return (
    <div data-testid="unsaved-modal">
      <ConfirmPopup
        open={unsavedModalOpen}
        description={<div>You have unsaved changes. Are you sure you want to discard them?</div>}
        title="Unsaved changes"
        okButtonProps={{
          variant: 'destructive',
          btnTxt: 'Yes, Proceed',
          onClick: () => handleClick(true),
        }}
        cancelButtonProps={{
          onClick: () => handleClick(false),
          btnTxt: 'No, Go back',
        }}
      />
    </div>
  )
}
